export default "__VITE_ASSET__vRTaL4Ua__"